import { createAction, type Middleware } from "@reduxjs/toolkit";

/**
 * Drops every RTK Query cache (SFRESTO-164): dispatched on logout so the next
 * user on the same tab never sees the previous user's cached data.
 *
 * A plain action, so `src/lib/logout.ts` and `baseQuery.ts` can dispatch it
 * without importing the API slices (which import `baseQuery.ts`).
 */
export const resetApiCaches = createAction("app/resetApiCaches");

interface ResettableApi {
  util: { resetApiState: () => { type: string } };
}

/** Turns `resetApiCaches` into `resetApiState()` on each given API slice. */
export const createApiResetMiddleware =
  (apis: ResettableApi[]): Middleware =>
  (store) =>
  (next) =>
  (action) => {
    const result = next(action);
    if (resetApiCaches.match(action)) {
      apis.forEach((api) => store.dispatch(api.util.resetApiState()));
    }
    return result;
  };
